import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_input, {
      modelValue: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
      debounce: "600",
      placeholder: "Search law firms...",
      class: "q-mx-md",
      borderless: "",
      autofocus: ""
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, {
          name: "fa fa-search",
          style: {"font-size":"1.25rem"}
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"])
  ]))
}